<!--
  The image IS the control. (CHAT-995)

  There used to be a separate dashed drop zone carrying an "Upload Image" button under
  the preview, which cost a whole row in every narrow column it appeared in and made the
  picture itself inert. The affordance now lives ON the picture: hover or focus it and an
  overlay invites the edit, and the same click, drag-drop, keyboard and file-picker
  behaviour sits underneath. Every consumer gets this — bot settings, channel edit,
  audience edit and onboarding step 4.
-->
<div class="image-upload-container">
  <div
    class="image-edit"
    [class.drag-over]="dragOver"
    [class.uploading]="uploading"
    [class.disabled]="disabled"
    role="button"
    [attr.tabindex]="disabled || uploading ? null : 0"
    [attr.aria-label]="config.dropText || 'Change image'"
    [attr.aria-disabled]="disabled || uploading ? 'true' : null"
    [attr.title]="disabled ? null : (config.dropText || 'Change image')"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
    (drop)="onDrop($event)"
    (click)="triggerFileInput()"
    (keydown.enter)="triggerFileInput()"
    (keydown.space)="$event.preventDefault(); triggerFileInput()">
    <div class="checkered-background">
      <img
        [src]="previewSrc"
        [alt]="value ? 'Current image' : 'Default logo'"
        [style.width.px]="previewSize"
        [style.height.px]="previewSize" />
    </div>

    <!-- Hover/focus affordance. aria-hidden: the wrapper already carries the label. -->
    <div class="image-edit__overlay" *ngIf="!uploading" aria-hidden="true">
      <i class="fa fa-pencil-alt"></i>
      <span>{{ config.dropText || 'Change image' }}</span>
    </div>

    <!--
      The ring's strokes are the PINNED media-overlay pair, not the page's progress
      tokens. It is drawn on --media-scrim over an arbitrary user image, so a token that
      follows the theme is wrong here: --brand-mark is #22335a in light, which is 1.69:1
      on that scrim, and --progress-track-bg is #252423 in dark, which is 1.36:1. Raised
      in review on PR #338. (CHAT-995)
    -->
    <div class="image-edit__progress" *ngIf="uploading">
      <div class="progress-circle">
        <svg width="60" height="60">
          <circle cx="30" cy="30" r="25" fill="none" stroke="var(--media-scrim-track)" stroke-width="4" />
          <circle
            cx="30"
            cy="30"
            r="25"
            fill="none"
            stroke="var(--media-scrim-ink)"
            stroke-width="4"
            [attr.stroke-dasharray]="157"
            [attr.stroke-dashoffset]="157 - (157 * uploadProgress / 100)"
            style="transform: rotate(-90deg); transform-origin: 30px 30px" />
        </svg>
        <span class="progress-text">{{ uploadProgress }}%</span>
      </div>
    </div>
  </div>

  <!-- Hidden file input -->
  <input
    type="file"
    [id]="inputId"
    [accept]="config.allowedTypes?.join(',')"
    style="display: none"
    [disabled]="disabled || uploading"
    (change)="onFileSelected($event)" />
</div>
